export default __webpack_public_path__ + "static/media/portadavideoplanificacion5.508b3570.png";